import Btn from './btn';

export enum BannerModifier {
  HAS_MARGIN = 'hasMargin',
}

export interface BannerProps {
  title: string;
  headline: string;
  subline: string;
  btnText: string;
  modifier?: BannerModifier;
}

const onNavigate = (url: string) => {
  if (url && url.length) {
    window.location.href = url;
  }
};

// TODO: Button click action CB

function Banner(props: BannerProps) {
  return (
    <div className={`ct_banner ${props.modifier ? `_${props.modifier}` : ''}`}>
      <div className="ct_banner-title">{props.title}</div>
      <div className="ct_banner-headline">{props.headline}</div>
      <div className="ct_banner-subline">{props.subline}</div>
      <div className="ct_banner-actions">
        <Btn type="primary" text={props.btnText} onClick={() => onNavigate('pro.php')} />
      </div>
    </div>
  );
}

Banner.defaultProps = { ...{} };

export default Banner;
